export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TestComponent.vue?vue&type=template&id=b8e5ca24&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/TestComponent.vue?vue&type=template&id=b8e5ca24&scoped=true
// module id = 67
// module chunks = 0